export default __webpack_public_path__ + "static/media/32t.adaa9e23.jpg";